module.exports = __webpack_public_path__ + "static/media/icon1u.daff4bd1.svg";